<template>
  <div
    class="h-full overflow-y-auto portal-container overflow-x-hidden homepage-index bg-no-repeat"
    :class="{
      'gray-scale': systemSetting.homeAsh,
    }"
    :style="{
      backgroundImage: theme,
    }"
    @scroll="onScroll"
    ref="homeIndex"
  >
    <Header :logo="systemSetting.logo" @heightChange="(val) => (headerHeight = val)" />
    <div class="mb-20px" :style="{ minHeight: `calc(100vh - ${this.headerHeight + 120}px)` }">
      <router-view></router-view>
    </div>
    <Footer></Footer>
    <div class="absolute tool-bar">
      <el-tooltip content="返回首页" placement="top">
        <div
          class="to-home w-45px h-45px cursor-pointer mb-6px"
          @click="toHome"
          v-if="
            $route.path !== `${routerBase}/integration/portal/homepage` ||
              $route.query.columnId !== homePageColumnId
          "
        ></div>
      </el-tooltip>
      <el-tooltip content="回到顶部" placement="top">
        <div
          class="to-top w-45px h-45px cursor-pointer"
          @click="toTop"
          v-if="scrollTop > pageHeight"
        ></div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { SystemSettingApi, ColumApi } from '@wiz-api/workbench-std'
import { EafTenantApi } from '@wiz-api/eaf-tenant-management'

const systemSettingApi = new SystemSettingApi()
const eafTenantApi = new EafTenantApi()
const columnApi = new ColumApi()
const Footer = () => {
  return import('../components/Footer')
}
const Header = () => {
  return import('../components/Header')
}

export default {
  name: 'ProtalHome',
  components: {
    Footer,
    Header,
  },
  data() {
    return {
      headerHeight: 0,
      systemSetting: {
        themed: '',
      },
      themeBg: {
        newYear: require('../image/newYearBg.png'),
      },
      theme: '',
      defaultTitle: '',
      pageHeight: 0,
      scrollTop: 0,
      homePageColumnId: null,
    }
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  methods: {
    async getColumnTree() {
      const [err, res] = await columnApi.tree(0, {
        isIncludeHomeColumn: true,
      })
      if (!err && res.length) {
        this.homePageColumnId = _.find(res, { isHomeColumn: true })
      }
    },
    async getSystemSetting() {
      const [err, res] = await systemSettingApi.getSystemSetting()
      if (!err) {
        this.systemSetting = res || {}
        this.theme = res.themed ? `url(${this.themeBg[res.themed]})` : 'none'
        const root = document.querySelector(':root')
        root.style.setProperty('--portalPrimaryColor', res.systemColor || '#c11920')
        root.style.setProperty('--portalPrimaryBgColor', `${res.systemColor}14` || '#c1192014')
        localStorage.setItem('portalPrimaryColor', res.systemColor || '#c11920')
      }
    },
    async getTenantInfo() {
      const { tenantName } = Wiz.globalSettings.globalConfig
      if (!tenantName) return
      const [err, res] = await eafTenantApi.getPublishByTenantName({ name: tenantName })
      if (!err && res.detail) {
        if (window.history.length === 1) {
          // 记录默认title
          this.defaultTitle = res.detail.name
        }
        // 未登录状态下没有缓存企业信息，需手动设置icon
        document.querySelector("link[rel='icon']").href = `${this.fileUrl}${res.detail.icon}`
      }
    },
    onScroll(e) {
      this.scrollTop = e.target.scrollTop
    },
    toHome() {
      this.$router.push({
        path: `${this.routerBase}/integration/portal/homepage`,
      })
    },
    toTop() {
      this.$refs.homeIndex.scrollTop = 0
    },
  },
  created() {
    if (window.history.length > 1) {
      // 记录默认title
      this.defaultTitle = document.title
    }
    this.getSystemSetting()
    this.getTenantInfo()
    this.getColumnTree()
  },
  mounted() {
    const currentTheme = Wiz.globalSettings.layout.config.defaultTheme
    document.body.classList.add('h-full', currentTheme)
    this.pageHeight = window.innerHeight
  },
  deactivated() {
    // 离开门户时还原title
    document.title = this.defaultTitle
  },
  beforeDestroy() {
    // 离开门户时还原title
    document.title = this.defaultTitle
  },
}
</script>

<style socped lang="scss">
.gray-scale {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  transition: filter 0.5s;
}
.homepage-index {
  background-size: 100% 77%;
  .tool-bar {
    right: calc((100% - 1180px) / 2 - 55px);
    bottom: 110px;
    & > div {
      background-size: 100% 100%;
      &.to-top {
        background: url('../image/to_top.png') 0 0 no-repeat;
      }
      &.to-home {
        background: url('../image/to_home.png') 0 0 no-repeat;
      }
    }
  }
}
</style>
